module.exports = __webpack_public_path__ + "static/img/deco1.9ab20c60.jpg";